export const orangeScreenReport = {
	title: "Reporte de Pantalla Naranja",
	subtitle: "Lista con todas las ocurrencias en el período del evento.",
	filters: {
		employee: {
			label: "Nombre del operador",
			placeholder: "Ingrese el nombre del operador",
		},
		deviceFingerprint: {
			label: "PDV ID",
			placeholder: "Ingrese el ID del PDV",
		},
	},
	columns: {
		date: "Fecha/hora de la ocurrencia",
		employee: "Operador",
		deviceId: "PDV ID",
		zigDeviceUid: "ID de la Tarjeta",
	},
	filename: "reporte-de-pantalla-naranja",
};
